import React, { useState } from 'react'
import './styles/LoginRegister.css'
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useModal } from '../contexts/ModalContext';
import { auth } from '../firebase/config';
import { ReactComponent as GoogleLogo } from '../assets/googleLogo.svg'
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";
import { createUserIfNotExists } from '../api/UserAPI';
import { Oval } from 'react-loader-spinner';
import logo from '../assets/newro-beige-logo.svg'

export default function Login({ handleClose }) {
    const { openModal } = useModal();
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    const [isloading, setisloading] = useState(false);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin()
        }
    }

    function navTo(whereTo) {
        handleClose()
        openModal(whereTo)
    }

    const handleLogin = async () => {
        try {
            setisloading(true);
            await signInWithEmailAndPassword(auth, email.trim(), password);
            openModal("alert", {
                alertProps: { type: 2, message: "Logged in!" },
            });
            handleClose()
        } catch (err) {
            openModal("alert", {
                alertProps: { type: 0, message: err.code },
            });
        }
        setisloading(false);
    };

    const handleGoogleAuth = async (e) => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                // The signed-in user info.
                const user = result.user;
                createUserIfNotExists(user)
                // IdP data available using getAdditionalUserInfo(result)
                // ...
                openModal("alert", {
                    alertProps: { type: 2, message: "Logged in!" },
                });
                handleClose()
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                openModal("alert", {
                    alertProps: { type: 0, message: errorCode },
                });
                // ...
            });
    };

    return (
        <div className='backdrop' onClick={handleClose}>
            <div className='login-modal-body' onClick={(e) => e.stopPropagation()} >
                <div className='login-top'>
                    <div class="company-branding">
                        <div class="company-logo">
                            <img src={logo} />
                        </div>
                        <span class="company-name">newro</span>
                    </div>
                    {/* <svg style={{ backgroundColor: 'var(--color-primary)' }} viewBox='0 0 1400 200' id="svg2" height="90" width="100%">
                        <path transform='scale(1,1)' stroke={'var(--color-primary)'} fill={'white'} id="wave45" title="no"
                            d="M0,64L48,90.7C96,117,192,171,288,170.7C384,171,480,117,576,122.7C672,128,768,192,864,197.3C960,203,1056,149,1152,122.7C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                    </svg> */}
                    <button className='log-close-button' style={{ backgroundColor: 'transparent' }} onClick={handleClose}>
                        <CloseIcon sx={{ color: 'var(--color-secondary)', fontSize: '24px' }} />
                    </button>
                </div>
                {/* The form */}
                <div className="login-inputs">
                    <h3 style={{ color: 'black', margin: 0 }}>Login</h3>
                    <div className="login-email">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="email-input"
                            type="text"
                            placeholder="Enter your email"
                            onChange={e => setemail(e.target.value)}
                        />
                    </div>

                    <div className="login-password">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="password-input"
                            type={passwordVisibility ? "text" : "password"}
                            placeholder="Enter your password"
                            onChange={e => setpassword(e.target.value)}
                        />
                        {passwordVisibility ? (
                            <VisibilityIcon
                                className="visibility-icon"
                                onClick={() => setPasswordVisibility(!passwordVisibility)}
                            />
                        ) : (
                            <VisibilityOffIcon
                                className="visibility-icon"
                                onClick={() => setPasswordVisibility(!passwordVisibility)}
                            />
                        )}
                    </div>
                    {/* The forgot password */}
                    <div className="login-forgot-password">
                        <p className='to-forgot-btn' onClick={() => navTo('forgot')}  >Forgot password ? </p>
                    </div>
                    <button onClick={() => handleLogin()} className="login-btn">
                        {isloading ? (
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        ) : (
                            "Login"
                        )}
                    </button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <hr style={{ width: '150px', height: '0px', border: '1px solid lightgray' }}></hr>
                    <p style={{ color: 'lightgray' }}>or</p>
                    <hr style={{ width: '150px', height: '0px', border: '1px solid lightgray' }}></hr>
                </div>
                <div className='login-bottom'>
                    <button onClick={() => handleGoogleAuth()} className="google-btn">
                        <GoogleLogo />
                        <h4>Continue with Google</h4>
                        {/* <GoogleLogo /> */}
                    </button>
                    <p className='t-c-text'>New to Newro? <span onClick={() => navTo('register')} className='to-register-btn'>Sign up</span></p>
                </div>
            </div>
        </div>
    )
}
